import axios from 'axios'
const AGE_OFFSET = 30000

export const state = {
  counts: [{},
  ]
}

export const getters = {
  getProjectDocumentCounts: (state) => (id) => {
    const intId = parseInt(id, 10)
    const countObj = state.counts.find(el => el.projectId === intId)
    if (countObj === undefined) {
      return {}
    }
    return countObj.data;
  },
  getCustomerDocumentCounts: (state) => (id) => {
    const intId = parseInt(id, 10)
    const countObj = state.counts.find(el => el.customerId === intId)
    if (countObj === undefined) {
      return {}
    }
    return countObj.data;
  },
  getProjectDocumentCountsAge: (state) => (id) => {
    const intId = parseInt(id, 10)
    const countObj = state.counts.find(el => el.projectId === intId)
    if (countObj === undefined) {
      return 0
    }
    return countObj.countsAge
  },
  getCustomerDocumentCountsAge: (state) => (id) => {
    const intId = parseInt(id, 10)
    const countObj = state.counts.find(el => el.customerId === intId)
    if (countObj === undefined) {
      return 0
    }
    return countObj.countsAge
  }
}

export const mutations = {
  SET_PROJECT_DOCUMENT_COUNTS (state, payload) {
    const intId = parseInt(payload.projectId, 10)
    const initial = state.counts.find(el => el.projectId === intId)
    if (initial !== undefined) {
      initial.data = payload.data
      initial.countsAge = Date.now()
    } else {
      const newDocs = {
        projectId: payload.projectId,
        countsAge: Date.now(),
        data: payload.data,
      }
      state.counts.push(newDocs)
    }
  },
  SET_CUSTOMER_DOCUMENT_COUNTS (state, payload) {
    const intId = parseInt(payload.customerId, 10)
    const initial = state.counts.find(el => el.customerId === intId)
    const data = {};
    if (payload.data) {
      for (const [key, value] of Object.entries(payload.data)) {
        value.forEach(({ status, total }) => {
          data[key] = {...data[key]};
          data[key][status] = total;
        })
      }
    }
    if (initial !== undefined) {
      initial.data = data
      initial.countsAge = Date.now()
    } else {
      const newDocs = {
        customerId: payload.customerId,
        countsAge: Date.now(),
        data: data,
      }
      state.counts.push(newDocs)
    }
  },
  SET_DOCUMENT_COUNT_AGE (state, payload) {
    const intId = parseInt(payload.projectId, 10)
    const initial = state.counts.find(el => el.projectId === intId)
    if (initial !== undefined){
      initial.countsAge = payload.data
    }else{
      const newDocs = {
        projectId: payload.projectId,
        countsAge: payload.data,
        data: {},
      }
      state.counts.push(newDocs)
    }
  },
}

export const actions = {
  async updateProjectDocumentCounts({ commit, getters }, { projectId }) {
    const id = parseInt(projectId, 10)
    if ((getters.getProjectDocumentCountsAge(id) + AGE_OFFSET) < Date.now()){
      const stats = await axios.get(`/projects/${id}/stats` )
      commit('SET_PROJECT_DOCUMENT_COUNTS', { data: stats.data, projectId: id})
    }
  },
  async updateCustomerDocumentCounts({ commit, getters }, { customerId }) {
    const id = parseInt(customerId, 10)
    if ((getters.getCustomerDocumentCountsAge(id) + AGE_OFFSET) < Date.now()){
      const stats = await axios.get(`/customers/${id}/stats` )
      commit('SET_CUSTOMER_DOCUMENT_COUNTS', { data: stats.data, customerId: id})
    }
  },
  searchDocuments({ commit }, params = {}) {
    return axios.get('/documents/search', { params })
  },
  resolveDocuments({ commit }, params = {}) {
    return axios.get(`/documents/search`, { params })
  },
  resolveDocumentFilters({ commit }) {
    return axios.get(`/documents/filters`)
  },
}
